import { EExceptionStatus } from '@src/tools/error-tracker/types/Constants'
import { SelectValueListItem } from '@src/shared/types/SelectValueListItem'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export function useExceptionStatuses(): SelectValueListItem[] {
  const { t } = useTranslation()

  return useMemo(
    () => [
      { label: t('exceptionStatus.ticketAssigned'), value: EExceptionStatus.TicketAssigned as string },
      { label: t('exceptionStatus.closed'), value: EExceptionStatus.Closed as string },
      { label: t('exceptionStatus.ignored'), value: EExceptionStatus.Ignored as string },
    ],
    [t],
  )
}
